<div class="smart-filter-card" (click)="buttonClicked()">
  <div class="content-container">
    <img class="plus-icon" [src]="iconSrc" alt="buttonIcon" />
    <div class="text-container ms-1">
      <div class="smart-filter-name">{{ text }}</div>
    </div>
  </div>
</div>
